numeral.register('locale', 'km', {
    delimiters: {
        thousands: ',',
        decimal: '.',
    },
    abbreviations: {
        thousand: 'មយពាន់',
        million: 'យលាន',
        billion: 'យពាន់លាន',
        trillion: 'សែនកោដិ',
    },
    ordinal: () => '.',
    currency: {
        symbol: '៛',
    },
});
